import useSWR from 'swr'
import { Current_User } from '@graphql/queries'
import { preventPublicRequest } from '@helpers/api'

const useCurrentUser = () => {
  const { data, error, mutate, isValidating } = useSWR(
    preventPublicRequest(Current_User)
  )

  return {
    currentUser: data?.currentUser,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useCurrentUser }
